var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("exchangeRate.title")))]),
      _c("delegation-info-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    [
                      _c("date-picker", {
                        staticClass: "mr-2",
                        attrs: {
                          placeholder: _vm.$t("global.any"),
                          prependIcon: "fa-calendar",
                          model: _vm.date,
                          clearable: true,
                          label:
                            _vm.toDate == null
                              ? _vm.$t("exchangeRate.date")
                              : _vm.$t("exchangeRate.fromDate")
                        },
                        on: {
                          "update:model": function($event) {
                            _vm.date = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("date-picker", {
                        attrs: {
                          placeholder: _vm.$t("global.any"),
                          prependIcon: "fa-calendar",
                          model: _vm.toDate,
                          label: _vm.$t("exchangeRate.toDate"),
                          clearable: true
                        },
                        on: {
                          "update:model": function($event) {
                            _vm.toDate = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  prependIcon: "attach_money",
                  label: _vm.$t("exchangeRate.currency"),
                  placeholder: _vm.$t("global.any"),
                  items: _vm.currencyList,
                  "hide-details": "",
                  multiple: ""
                },
                model: {
                  value: _vm.selectedCurrency,
                  callback: function($$v) {
                    _vm.selectedCurrency = $$v
                  },
                  expression: "selectedCurrency"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredItems,
          search: _vm.search,
          loading: _vm.loading,
          "must-sort": "",
          "sort-by": _vm.pagination.sortBy,
          "sort-desc": _vm.pagination.descending,
          "footer-props": { "items-per-page-options": [5, 10, 25] }
        },
        on: {
          "update:sortBy": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sort-by": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sortDesc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sort-desc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.currency_code))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.effective_date))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.mid))
                  ]),
                  _c("td", { staticClass: "text-left" }, [_vm._v("NBP")])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }